import { AfterViewInit, Component, inject } from '@angular/core';
import { ICRUDOptions } from '@phx-erp/shared';
import { SearchInput, Tag, TagSearchInput } from '../../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../../shared/components/genericBaseModelDropDown';
import { TagsService } from '../../../../shared/services/tags.service';

@Component({
  selector: 'app-formly-tag-dropdown',
  template: '',
  providers: [TagsService],
  standalone: true
})
export class FormlyTagDropdownComponent extends GenericBaseModelDropDown<Tag, TagSearchInput> implements AfterViewInit {

  constructor() {
    super(inject(TagsService), 'Tag');
    this.useIdentifierTemplate.set(true);
    this.useIdentifierDescriptionTemplate.set(false);
    this.optionLabelSig.set('identifier');
    this.multiple.set(true);
  }

  override ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.applyTagEntityFilter();
  }

  override async executeSearch(searchInput: SearchInput, options?: ICRUDOptions) {
    this.applyTagEntityFilter(searchInput as TagSearchInput);
    return super.executeSearch(searchInput, options);
  }

  private applyTagEntityFilter(searchInput: TagSearchInput = this.si): void {
    const entityType = this.props?.attributes?.['entityType'];
    if (typeof entityType === 'string' && entityType.length > 0) {
      searchInput.entity = entityType;
    }
  }

}
